<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
       <div class="flex items-center space-x-2">
         <button (click)="goBackToList()" mat-icon-button class="text-gray-600 hover:text-gray-800">
           <mat-icon>arrow_back</mat-icon>
         </button>
         <h2 class="text-2xl font-bold mb-0">
           {{ isNewClient ? ('CLIENT_EDIT.TITLE_NEW' | translate) : (isEditMode ? ('CLIENT_EDIT.TITLE_EDIT' | translate) : ('CLIENT_EDIT.TITLE_VIEW' | translate)) }}: 
           <span *ngIf="!isNewClient && client">{{ client.suchbegriff }}</span>
         </h2>
       </div>
       <div class="flex space-x-2"></div>
     </div>
    <div class="row">
      <div class="col-md-12 order-md-1 order-sm-2">

        <!-- Loading State for Existing Client -->
        <div *ngIf="isLoading && !isNewClient" class="flex justify-center items-center py-8">
          <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
          <span class="ml-4 text-gray-600">{{ 'CLIENT_EDIT.LOADING' | translate }}</span>
        </div>

        <!-- Combined View/Edit Mode -->
         <form [formGroup]="clientForm" [class.opacity-50]="isLoading && !isNewClient" [class.pointer-events-none]="isLoading && !isNewClient">
           <mat-tab-group animationDuration="0ms" *ngIf="!isNewClient" (selectedIndexChange)="selectedTabIndex = $event" [selectedIndex]="selectedTabIndex">
             <mat-tab [label]="'CLIENT_EDIT.TAB_INFO' | translate">
               <div class="step-container d-flex align-items-start flex-column">
                 <div class="container-fluid mt-6">
                   <div class="form">
                     <div class="row">
                       <div class="col-12 col-lg-6">
                        <!-- Suchbegriff -->
                        <div class="form-group">
                          <label class="form-label" for="suchbegriff">{{ 'CLIENT_EDIT.FIELD_NAME' | translate }}</label>
                          <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                            {{ client?.suchbegriff || '-' }}
                          </div>
                          <input
                            *ngIf="isEditMode || isNewClient"
                            type="text"
                            class="form-control"
                            id="suchbegriff"
                            formControlName="suchbegriff"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            [placeholder]="'CLIENT_EDIT.FIELD_NAME' | translate"
                            [class.is-invalid]="isFieldInvalid('suchbegriff')" />
                          <div *ngIf="isFieldInvalid('suchbegriff')" class="text-red-500 text-sm">{{ 'CLIENT_EDIT.VALIDATION_NAME' | translate }}</div>
                        </div>

                         <!-- Status ID -->
                         <div class="form-group">
                           <label class="form-label" for="status_id">{{ 'CLIENT_EDIT.FIELD_STATUS' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.status_id ? getStatusText(client.status_id) : '-' }}
                           </div>
                           <select
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="status_id"
                             formControlName="status_id"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                             <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                               {{ status.label }}
                             </option>
                           </select>
                         </div>

                         <!-- Startdatum -->
                         <div class="form-group">
                           <label class="form-label" for="startdatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_START' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.startdatum) || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="startdatum"
                             formControlName="startdatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Enddatum -->
                         <div class="form-group">
                           <label class="form-label" for="enddatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_END' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.enddatum) || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="enddatum"
                             formControlName="enddatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Address Section -->
                         <div class="form-group">
                           <label class="form-label" for="strasse">{{ 'CLIENT_EDIT.FIELD_STREET' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.strasse || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="strasse"
                             formControlName="strasse"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_STREET' | translate" />
                           <div *ngIf="clientForm.get('strasse')?.invalid && clientForm.get('strasse')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_STREET' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="plz">{{ 'CLIENT_EDIT.FIELD_ZIP' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.plz || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="plz"
                             formControlName="plz"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_ZIP' | translate" />
                           <div *ngIf="clientForm.get('plz')?.invalid && clientForm.get('plz')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_ZIP' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="ort">{{ 'CLIENT_EDIT.FIELD_CITY' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.ort || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="ort"
                             formControlName="ort"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_CITY' | translate" />
                           <div *ngIf="clientForm.get('ort')?.invalid && clientForm.get('ort')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_CITY' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="land">{{ 'CLIENT_EDIT.FIELD_COUNTRY' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.land || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="land"
                             formControlName="land"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_COUNTRY' | translate" />
                           <div *ngIf="clientForm.get('land')?.invalid && clientForm.get('land')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_COUNTRY' | translate }}
                           </div>
                         </div>
                       </div>

                       <div class="col-12 col-lg-6">
                          <!-- Anmerkungen Chat Section -->
                          <div class="form-group" *ngIf="!isEditMode && !isNewClient">
                            <div class="flex items-center justify-between mb-2">
                              <label class="form-label mb-0" for="anmerkungen">{{ 'CLIENT_EDIT.NOTES_LABEL' | translate }}</label>
                              <span *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                    class="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                                {{ sortedAnmerkungen.length }}
                              </span>
                            </div>

                            <!-- Anmerkungen List (scrollable) -->
                            <div *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                 class="space-y-2 max-h-[350px] overflow-y-auto pr-2 mb-4 border border-gray-200 rounded-lg p-3 bg-gray-50">
                              <div *ngFor="let anmerkung of sortedAnmerkungen; let i = index" 
                                   class="flex items-start gap-3 p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                                <!-- User Avatar -->
                                <div class="flex-shrink-0">
                                  <div class="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-medium">
                                    {{ getUserInitials(anmerkung.username) }}
                                  </div>
                                </div>
                                
                                <!-- Anmerkung Content -->
                                <div class="flex-1 min-w-0">
                                  <div class="flex items-center gap-2 mb-1">
                                    <span class="text-sm font-medium text-gray-900">{{ anmerkung.username }}</span>
                                    <span class="text-xs text-gray-500">{{ formatAnmerkungDate(anmerkung.datetime) }}</span>
                                  </div>
                                  <div class="text-sm text-gray-700 whitespace-pre-wrap">{{ anmerkung.anmerkung }}</div>
                                </div>
                                
                                <!-- Action Button (admin only - delete only) -->
                                <div *ngIf="canEditAnmerkungen()" class="flex-shrink-0">
                                  <button
                                    (click)="deleteAnmerkung(anmerkung)"
                                    mat-icon-button
                                    class="mat-icon-button-small"
                                    [title]="'COMMON.DELETE' | translate">
                                    <mat-icon>close</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!sortedAnmerkungen || sortedAnmerkungen.length === 0" 
                                 class="text-center py-6 text-sm text-gray-500 mb-4 border border-gray-200 rounded-lg bg-gray-50">
                              <mat-icon class="w-8 h-8 mb-2 text-gray-400">comment</mat-icon>
                              <p>{{ 'CLIENT_EDIT.NOTES_EMPTY' | translate }}</p>
                            </div>

                            <!-- Add New Anmerkung Section -->
                            <div class="mt-4">
                              <label class="block text-sm font-medium text-gray-700 mb-2">{{ 'CLIENT_EDIT.NOTES_ADD' | translate }}</label>
                              <textarea
                                #anmerkungTextarea
                                [(ngModel)]="newAnmerkungText"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onAnmerkungTextChange($event)"
                                [disabled]="isAddingAnmerkung"
                                rows="3"
                                class="w-full p-2.5 border border-gray-300 rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                                [placeholder]="'CLIENT_EDIT.NOTES_PLACEHOLDER' | translate"></textarea>
                              <div class="flex justify-end mt-2">
                                <button
                                  type="button"
                                  (click)="addAnmerkungFromTemplate($event)"
                                  [disabled]="!canAddAnmerkung"
                                  mat-raised-button
                                  color="primary"
                                  class="!text-xs !px-4 !py-1.5 !h-auto !min-h-0">
                                  <span *ngIf="isAddingAnmerkung">{{ 'CLIENT_EDIT.NOTES_ADDING' | translate }}</span>
                                  <span *ngIf="!isAddingAnmerkung">{{ 'CLIENT_EDIT.NOTES_ADD_BTN' | translate }}</span>
                                </button>
                              </div>
                              <p *ngIf="isNewClient" class="text-xs text-gray-500 mt-1">
                                {{ 'CLIENT_EDIT.NOTES_SAVE_ON_NEW' | translate }}
                              </p>
                            </div>
                          </div>
                       </div>

                      <!-- Action Buttons moved below tabs (global bottom bar) -->
                   </div>
                </div>
              </div>
              </div>
            </mat-tab>
             
             <mat-tab [label]="'CLIENT_EDIT.TAB_CONTACTS' | translate">
                <div class="kontakte-tab-content w-11/12 mx-auto">
                  <app-kontakte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-kontakte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">contacts</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.CONTACTS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>
              
              <mat-tab [label]="'CLIENT_EDIT.TAB_LOCATIONS' | translate">
                <div class="standorte-tab-content w-11/12 mx-auto">
                  <app-standorte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-standorte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">location_on</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.LOCATIONS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>
              
              <mat-tab [label]="'CLIENT_EDIT.TAB_DOCUMENTS' | translate">
                <div class="dokumente-tab-content w-11/12 mx-auto">
                  <app-dokumente 
                    *ngIf="!isNewClient && client?.uuid" 
                    [tableName]="'standort'"
                    [isClientView]="true"
                    [clientId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-dokumente>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.DOCUMENTS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>
           </mat-tab-group>

           <!-- Bottom action bar for existing client (visible only on first tab: Kunde Information) -->
           <div *ngIf="!isNewClient && selectedTabIndex === 0" class="mt-6 flex justify-between items-center">
             <!-- Left side - Delete button -->
             <div>
               <button
                 *ngIf="client && isEditMode"
                 (click)="deleteClient()"
                 mat-button
                 color="warn">
                 {{ 'COMMON.DELETE' | translate }}
               </button>
             </div>

             <!-- Right side - Action buttons -->
             <div class="flex space-x-4">
               <button
                 *ngIf="client && !isEditMode"
                 (click)="enterEditMode()"
                 mat-raised-button
                 color="primary">
                 {{ 'COMMON.EDIT' | translate }}
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="cancelEdit()"
                 mat-button>
                 {{ 'COMMON.CANCEL' | translate }}
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="saveClient()"
                 [disabled]="!clientForm.valid || isSaving"
                 mat-raised-button
                 color="primary">
                 <span *ngIf="isSaving">{{ 'CLIENT_EDIT.BTN_SAVING' | translate }}</span>
                 <span *ngIf="!isSaving">{{ 'COMMON.SAVE' | translate }}</span>
               </button>
             </div>
           </div>

           <!-- New Client Form (No Tabs) -->
           <div *ngIf="isNewClient" class="step-container d-flex align-items-start flex-column">
             <div class="container-fluid mt-6">
               <div class="form">
                 <div class="row">
                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="suchbegriff">{{ 'CLIENT_EDIT.FIELD_NAME' | translate }}</label>
                       <input
                         type="text"
                         class="form-control"
                         id="suchbegriff"
                         formControlName="suchbegriff"
                         [placeholder]="'CLIENT_EDIT.NAME_PLACEHOLDER' | translate"
                         [class.is-invalid]="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched"
                       />
                       <div *ngIf="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched" class="invalid-feedback">
                         {{ 'CLIENT_EDIT.NAME_REQUIRED' | translate }}
                       </div>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="status_id">{{ 'CLIENT_EDIT.FIELD_STATUS' | translate }}</label>
                       <select class="form-control" id="status_id" formControlName="status_id">
                         <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                           {{ status.label }}
                         </option>
                       </select>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="startdatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_START' | translate }}</label>
                       <input type="date" class="form-control" id="startdatum" formControlName="startdatum" placeholder="DD.MM.YYYY" />
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="enddatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_END' | translate }}</label>
                       <input type="date" class="form-control" id="enddatum" formControlName="enddatum" placeholder="DD.MM.YYYY" />
                     </div>
                   </div>
                 </div>
               </div>
               <!-- Action Buttons for New Client -->
               <div class="col-12 mt-6">
                 <div class="flex justify-end space-x-4">
                   <button (click)="cancel()" mat-button>{{ 'COMMON.CANCEL' | translate }}</button>
                   <button (click)="saveClient()" [disabled]="!clientForm.valid || isSaving" mat-raised-button color="primary">
                     <span *ngIf="isSaving">{{ 'CLIENT_EDIT.BTN_CREATING' | translate }}</span>
                     <span *ngIf="!isSaving">{{ 'CLIENT_EDIT.BTN_CREATE' | translate }}</span>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </form>

       </div>
     </div>
   </div>
 </div>
